import axios from "axios"; // 引入axios
import CryptoJS from "crypto-js";
import QS from "qs"; // 引入qs模块，用来序列化post类型的数据
import storage from "./storage.js";

// 十六位十六进制数作为密钥
// const SECRET_KEY = CryptoJS.enc.Utf8.parse("3333e6e143439161");
// 十六位十六进制数作为密钥偏移量
// const SECRET_IV = CryptoJS.enc.Utf8.parse("e3bbe7e3ba84431a");
const SECRET_KEY =
  "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKoR8mX0rGKLqzcWmOzbfj64K8ZIgOdHnzkXSOVOZbFu/TJhZ7rFAN+eaGkl3C4buccQd/EjEsj9ir7ijT7h96MCAwEAAQ==";
const SECRET_IV =
  "MIIBVAIBADANBgkqhkiG9w0BAQEFAASCAT4wggE6AgEAAkEAmc3CuPiGL/LcIIm7zryCEIbl1SPzBkr75E2VMtxegyZ1lYRD+7TZGAPkvIsBcaMs6Nsy0L78n2qh+lIZMpLH8wIDAQABAkEAk82Mhz0tlv6IVCyIcw/s3f0E+WLmtPFyR9/WtV3Y5aaejUkU60JpX4m5xNR2VaqOLTZAYjW8Wy0aXr3zYIhhQQIhAMfqR9oFdYw1J9SsNc+CrhugAvKTi0+BF6VoL6psWhvbAiEAxPPNTmrkmrXwdm/pQQu3UOQmc2vCZ5tiKpW10CgJi8kCIFGkL6utxw93Ncj4exE/gPLvKcT+1Emnoox+O9kRXss5AiAMtYLJDaLEzPrAWcZeeSgSIzbL+ecokmFKSDDcRske6QIgSMkHedwND1olF8vlKsJUGK3BcdtM8w4Xq7BpSBwsloE=";

const CancelToken = axios.CancelToken;
const AUTH_TOKEN_STORAGE_KEY = "_stoken";
const AUTH_TOKEN_EXPIRE_SECONDS = 30 * 24 * 3600;
const DEFAULT_CLIENT_ID = "e5cd7e4891bf95d1d19206ce24a7b321";
const API_BASE_URL = "https://api.ydleague.com/java-api";
const REFRESH_TOKEN_URL = `${API_BASE_URL}/v2/sto/auth/refresh`;
let refreshTokenPromise = null;

var service = axios.create({
  timeout: 600000,
});

const getStoredToken = () => storage.get(AUTH_TOKEN_STORAGE_KEY);

const persistToken = (tokenData) => {
  if (!tokenData || !tokenData.access_token) {
    return null;
  }
  storage.set(AUTH_TOKEN_STORAGE_KEY, tokenData, AUTH_TOKEN_EXPIRE_SECONDS);
  return tokenData;
};

const clearStoredToken = () => {
  storage.del(AUTH_TOKEN_STORAGE_KEY);
};

const notifyRelogin = () => {
  clearStoredToken();
  if (typeof window !== "undefined" && typeof window.requestLogin === "function") {
    window.requestLogin();
  }
};

const refreshAccessToken = async () => {
  const tokenData = getStoredToken();
  if (!tokenData || !tokenData.refresh_token) {
    return null;
  }
  if (!refreshTokenPromise) {
    refreshTokenPromise = service({
      method: "post",
      url: REFRESH_TOKEN_URL,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        clientId: tokenData.client_id || DEFAULT_CLIENT_ID,
      },
      data: {
        refreshToken: tokenData.refresh_token,
        clientId: tokenData.client_id || DEFAULT_CLIENT_ID,
      },
      skipAuthRefresh: true,
      cancelToken: new CancelToken(() => {}),
    })
      .then((res) => {
        if (res?.data?.code === 200 && res?.data?.data?.access_token) {
          return persistToken(res.data.data);
        }
        return null;
      })
      .catch(() => null)
      .finally(() => {
        refreshTokenPromise = null;
      });
  }
  return refreshTokenPromise;
};

service.interceptors.response.use(
  async (response) => {
    const { config, data } = response || {};
    if (config?.skipAuthRefresh) {
      if (data?.code === 401) {
        notifyRelogin();
      }
      return response;
    }
    if (data?.code !== 401) {
      return response;
    }
    const nextToken = await refreshAccessToken();
    if (!nextToken?.access_token) {
      notifyRelogin();
      return response;
    }
    return service({
      ...config,
      headers: {
        ...(config?.headers || {}),
        Authorization: `Bearer ${nextToken.access_token}`,
      },
      skipAuthRefresh: true,
    });
  },
  (error) => Promise.reject(error)
);

export const encryptBase64 = (str) => {
  return CryptoJS.enc.Base64.stringify(str);
};

const generateRandomString = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < 32; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const generateAesKey = () => {
  return CryptoJS.enc.Utf8.parse(generateRandomString());
};

/**
 * 使用密钥对数据进行加密
 * @param message
 * @param aesKey
 * @returns {string}
 */
export const encryptWithAes = (message, aesKey) => {
  const encrypted = CryptoJS.AES.encrypt(message, aesKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

/**
 * 加密方法
 * @param data
 * @returns {string}
 */
const encrypt = (data) => {
  if (typeof data === "object") {
    try {
      data = JSON.stringify(data);
    } catch (error) {
      console.log("encrypt error:", error);
    }
  }
  const dataHex = CryptoJS.enc.Utf8.parse(data);
  const encrypted = CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
    iv: SECRET_IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString();
};

// /**
//  * 解密方法
//  * @param data
//  * @returns {string}
//  */
// const decrypt = (data) => {
//   const encryptedHexStr = CryptoJS.enc.Hex.parse(data);
//   const str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
//   const decrypt = CryptoJS.AES.decrypt(str, SECRET_KEY, {
//     iv: SECRET_IV,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7,
//   });
//   const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
//   return decryptedStr.toString();
// };

export default {
  // baseURL: "http://127.0.0.1:8080",
  // baseURL: "http://localhost:8080",
  baseURL: API_BASE_URL,
  clientId: DEFAULT_CLIENT_ID,
  checkCode(res) {
    return res?.data?.code !== 401;
  },
  //getLogin请求
  getLogin(url, param) {
    url = this.baseURL + url;
    const params = JSON.parse(JSON.stringify(param || {}));
    const _ukit = storage.get("_ukit");
    if (_ukit) {
      params.u = _ukit.id;
    }
    const _skit = storage.get("_skit");
    if (_skit) {
      params.s = _skit.id;
    }
    let headers = {
      clientId: this.clientId,
    };
    const _token = getStoredToken();
    if (_token) {
      headers.Authorization = "Bearer " + _token.access_token;
    }
    // console.log("_stoken", _token);
    return new Promise((resolve, reject) => {
      service({
        method: "get",
        url,
        headers,
        params: params,
        cancelToken: new CancelToken(() => {}),
      })
        .then((res) => {
          //axios返回的是一个promise对象
          resolve(res.data); //resolve在promise执行器内部
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getStream() {},
  //get请求
  get(url, param) {
    url = this.baseURL + url;
    const params = JSON.parse(JSON.stringify(param || {}));
    const _ukit = storage.get("_ukit");
    if (_ukit) {
      params.u = _ukit.id;
    }
    const _skit = storage.get("_skit");
    if (_skit) {
      params.s = _skit.id;
    }
    let headers = {
      clientId: this.clientId,
    };
    const _token = getStoredToken();
    if (_token) {
      headers.Authorization = "Bearer " + _token.access_token;
    }
    // console.log("_stoken", _token);
    return new Promise((resolve, reject) => {
      service({
        method: "get",
        url,
        headers,
        params: params,
        cancelToken: new CancelToken(() => {}),
      })
        .then((res) => {
          //axios返回的是一个promise对象
          this.checkCode(res);
          resolve(res.data); //resolve在promise执行器内部
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  //post请求
  post(url, param, encrypted) {
    url = this.baseURL + url;
    let params = JSON.parse(JSON.stringify(param || {}));
    const _ukit = storage.get("_ukit");
    if (_ukit) {
      params.u = _ukit.id;
    }
    let headers = {
      "Content-Type": "application/json;charset=UTF-8",
      clientId: this.clientId,
    };
    const _token = getStoredToken();
    if (_token) {
      headers.Authorization = "Bearer " + _token.access_token;
    }

    const _skit = storage.get("_skit");
    if (_skit) {
      params.s = _skit.id;
    }

    for (let i in params) {
      if (params[i] !== 0 && !params[i]) {
        delete params[i];
      }
    }

    // console.log(encrypted);
    if (encrypted) {
      headers.isEncrypt = "true";
    }

    const isEncrypt = headers?.isEncrypt === "true";
    // 当开启参数加密
    if (isEncrypt) {
      // 生成一个 AES 密钥
      const encryptHeader = "encrypt-key";
      const aesKey = generateAesKey();
      headers[encryptHeader] = encrypt(encryptBase64(aesKey));
      params =
        typeof params === "object"
          ? encryptWithAes(JSON.stringify(params), aesKey)
          : encryptWithAes(params, aesKey);
    }

    return new Promise((resolve, reject) => {
      service({
        method: "post",
        url,
        headers,
        data: params,
        cancelToken: new CancelToken(() => {}),
      })
        .then((res) => {
          this.checkCode(res);
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  //put请求
  put(url, param, encrypted) {
    url = this.baseURL + url;
    let params = JSON.parse(JSON.stringify(param || {}));
    const _ukit = storage.get("_ukit");
    if (_ukit) {
      params.u = _ukit.id;
    }
    let headers = {
      "Content-Type": "application/json;charset=UTF-8",
      clientId: this.clientId,
    };
    const _token = getStoredToken();
    if (_token) {
      headers.Authorization = "Bearer " + _token.access_token;
    }

    const _skit = storage.get("_skit");
    if (_skit) {
      params.s = _skit.id;
    }

    for (let i in params) {
      if (params[i] !== 0 && !params[i]) {
        delete params[i];
      }
    }

    if (encrypted) {
      headers.isEncrypt = "true";
    }

    const isEncrypt = headers?.isEncrypt === "true";
    if (isEncrypt) {
      const encryptHeader = "encrypt-key";
      const aesKey = generateAesKey();
      headers[encryptHeader] = encrypt(encryptBase64(aesKey));
      params =
        typeof params === "object"
          ? encryptWithAes(JSON.stringify(params), aesKey)
          : encryptWithAes(params, aesKey);
    }

    return new Promise((resolve) => {
      service({
        method: "put",
        url,
        headers,
        data: params,
        cancelToken: new CancelToken(() => {}),
      })
        .then((res) => {
          this.checkCode(res);
          resolve(res.data);
        })
        .catch((err) => {
          console.log(err, "异常");
        });
    });
  },
  //delete请求
  delete(url, param) {
    url = this.baseURL + url;
    const params = JSON.parse(JSON.stringify(param || {}));
    const _ukit = storage.get("_ukit");
    if (_ukit) {
      params.u = _ukit.id;
    }
    const _skit = storage.get("_skit");
    if (_skit) {
      params.s = _skit.id;
    }
    let headers = {
      clientId: this.clientId,
    };
    const _token = getStoredToken();
    if (_token) {
      headers.Authorization = "Bearer " + _token.access_token;
    }
    return new Promise((resolve) => {
      service({
        method: "delete",
        url,
        headers,
        params,
        cancelToken: new CancelToken(() => {}),
      })
        .then((res) => {
          this.checkCode(res);
          resolve(res.data);
        })
        .catch((err) => {
          console.log(err, "异常");
        });
    });
  },
  //post请求
  postParam(url, param) {
    url = this.baseURL + url;
    const params = JSON.parse(JSON.stringify(param || {}));
    const _ukit = storage.get("_ukit");
    if (_ukit) {
      params.u = _ukit.id;
    }
    let headers = {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      clientId: this.clientId,
    };
    const _token = getStoredToken();
    if (_token) {
      headers.Authorization = "Bearer " + _token.access_token;
    }

    const _skit = storage.get("_skit");
    if (_skit) {
      params.s = _skit.id;
    }

    for (let i in params) {
      if (params[i] !== 0 && !params[i]) {
        delete params[i];
      }
    }

    return new Promise((resolve) => {
      service({
        method: "post",
        url,
        headers,
        data: params,
        cancelToken: new CancelToken(() => {}),
      })
        .then((res) => {
          this.checkCode(res);
          resolve(res.data);
        })
        .catch((err) => {
          console.log(err, "异常");
        });
    });
  },
  //post请求
  postBody(url, param) {
    url = this.baseURL + url;
    const params = JSON.parse(JSON.stringify(param || {}));
    const _ukit = storage.get("_ukit");
    if (_ukit) {
      params.u = _ukit.id;
    }
    let headers = {
      "Content-Type": "application/json",
      clientId: this.clientId,
    };
    const _token = getStoredToken();
    if (_token) {
      headers.Authorization = "Bearer " + _token.access_token;
    }
    return new Promise((resolve) => {
      service({
        method: "post",
        url,
        headers,
        params: params,
        cancelToken: new CancelToken(() => {}),
      })
        .then((res) => {
          this.checkCode(res);
          resolve(res.data);
        })
        .catch((err) => {
          console.log(err, "异常");
        });
    });
  },
  postForm(url, param) {
    url = this.baseURL + url;
    const params = JSON.parse(JSON.stringify(param || {}));
    const _ukit = storage.get("_ukit");
    if (_ukit) {
      params.u = _ukit.id;
    }
    let headers = {
      "Content-Type": "application/json",
      clientId: this.clientId,
    };
    const _token = getStoredToken();
    if (_token) {
      headers.Authorization = "Bearer " + _token.access_token;
    }
    return new Promise((resolve) => {
      service({
        method: "post",
        url,
        headers,
        data: QS.stringify(params, { indices: false }),
        cancelToken: new CancelToken(() => {}),
      })
        .then((res) => {
          this.checkCode(res);
          resolve(res.data);
        })
        .catch((err) => {
          console.log(err, "异常");
        });
    });
  },
  filePost: function (url, param) {
    console.log(param, "param");
    // const params = JSON.parse(JSON.stringify(param || {}));
    url = this.baseURL + url;
    let headers = {
      "Content-Type": "multipart/form-data;charset=UTF-8",
      clientId: this.clientId,
    };
    const _token = getStoredToken();
    if (_token) {
      headers.Authorization = "Bearer " + _token.access_token;
    }
    return new Promise((resolve) => {
      service({
        method: "post",
        url,
        headers: headers,
        data: param,
        cancelToken: new CancelToken(() => {}),
      })
        .then((res) => {
          this.checkCode(res);
          resolve(res.data);
        })
        .catch((err) => {
          console.log(err, "异常");
        });
    });
  },
};

// , { indices: false }
